import type { RootState } from "../store";

export const currentUserSelector = (state: RootState) => state.profile.currentUser;
export const currentOrgSelector = (state: RootState) => state.profile.organization;
export const jwtSelector = (state: RootState) => state.auth.jwt;
export const mfaChallengeSelector = (state: RootState) => state.auth.mfaChallenge;
